module.exports = __webpack_public_path__ + "img/cover_wibo_1.96e395e7.jpg";